export default {
  siteName: "哔咔动漫",
  siteTagline: "免费全集 | 哔咔漫画免费观看下拉式在线阅读",
  nav: {
    home: "首页",
    riman: "日漫",
    hanman: "韩漫",
    guoman: "国漫",
    wanjie: "完结",
    lianzai: "连载",
    about: "关于我们",
  },
  footer: {
    about: "关于哔咔",
    aboutDesc: "哔咔动漫——免费全集漫画在线平台，日漫韩漫国漫全免费，下拉式阅读体验，让漫画爱好者无门槛享受阅读乐趣。",
    quickLinks: "快速导航",
    categories: "漫画分类",
    contact: "联系我们",
    copyright: "© 2026 哔咔动漫 Bikadongman. 本站所有漫画资源仅供学习交流，请支持正版。",
  },
  breadcrumb: {
    home: "首页",
  },
  common: {
    readMore: "阅读更多",
    viewAll: "查看全部",
    hot: "热门",
    new: "最新",
    recommend: "推荐",
    loading: "加载中...",
    noData: "暂无数据",
  },
};